<template>
  <div class="leaderboard-page animate-slidein" v-if="!!clubInfo">
    <div class="note" v-if="isClubPresentation && !mobileView">
      <svg class="golf-ball-stand"><use xlink:href="#golf-ball-stand"></use></svg>
      <div class="pre-title" v-html="pageContent.pre_title"></div>
    </div>
    <div class="leaderboard-container">
      <div
        v-if="isClubPresentation || mobileView"
        class="bg-image"
        :style="{ 'background-image': 'url(' + (this.clubInfo.cover_img || '') + ')' }"
      >
      </div>
      <div
        class="inner"
        :class="[isClubPresentation ? 'club-presentation' : '']"
      >
        <leaderboard-info
          :userInfo="userInfo"
          :clubInfo="clubInfo"
          :clubData="clubData"
          :gameContent="gameContent"
          :pageContent="pageContent"
          :mobileView="mobileView"
          :showClubMemView="showClubMemView"
          :showScoreView="showScoreView"
          :selectedItem="selectedItem"
          :showClubView="showClubView"
          :showAllScores="showAllScores"
          :hideShowAllBtn="hideShowAllBtn"
          :isClubPresentation="isClubPresentation"
          @share="showShare=true"
        />
        <div class="leaderboard-list">
          <div class="title" v-if="!isClubPresentation">
            <img class="coin" :src="gameContent.badge" alt="" height="42.5" width="42.5" />
            <span>{{ pageContent.title }}</span>
          </div>
          <div class="btn-wrapper" v-if="!isClubPresentation">
            <button
              type="button"
              class="btn-score"
              :class="{ 'active': showScoreView }"
              :disabled="showLoader"
              @click="showScoreView=true;showClubMemView=false;showClubView=false;"
            >
              Stigatafla
            </button>
            <button
              type="button"
              class="btn-club"
              :class="{ 'active': showClubMemView }"
              :disabled="showLoader"
              @click="showScoreView=false;showClubMemView=true;showClubView=false;"
            >
              {{ clubInfo.short_name || 'Club' }}
            </button>
            <button
              type="button"
              class="btn-all-club"
              :class="{ 'active': !showScoreView && !showClubMemView }"
              :disabled="showLoader"
              @click="showScoreView=false;showClubMemView=false;showClubView=true;"
            >
              Allir klúbbar
            </button>
          </div>
          <div
            class="score-list"
            :class="[scoreData ? 'show' : '', showLoader ? 'loading' : '']"
            ref="scoreList"
            v-if="showScoreView && !isClubPresentation"
          >
            <div class="loader" v-if="showLoader"></div>
            <table width="100%">
              <thead>
                <tr>
                  <th width="102px"><div>Sæti</div></th>
                  <th width="325px"><div>Nafn</div></th>
                  <th width="177px"><div>Golfklúbbur</div></th>
                  <th><div>Stig</div></th>
                </tr>
              </thead>
              <tbody v-if="scoreData && scoreData.players.length">
                <tr
                  v-for="player in (showAllScores ? scoreData.players : scoreData.top_players)"
                  :key="player.key + player.name"
                  :class="[player.key === userInfo.key ? 'highlight' : '']"
                >
                  <td>
                    <div>
                      <svg v-if="player.rank === 1"><use xlink:href="#gold-crown-sm"></use></svg>
                      <svg v-else-if="player.rank === 2"><use xlink:href="#silver-crown-sm"></use></svg>
                      <svg v-else-if="player.rank === 3"><use xlink:href="#bronze-crown-sm"></use></svg>
                      <svg v-else><use xlink:href="#golf-ball-sm"></use></svg>
                      <span>{{ String(player.rank).padStart(2, '0') }}</span>
                    </div>
                  </td>
                  <td><div>{{ shortName(player.name) }}</div></td>
                  <td>
                    <div v-if="player.club && player.club.short_name">{{ player.club.short_name }}</div>
                    <div v-else>-</div>
                  </td>
                  <td><div>{{ player.best_score }}</div></td>
                </tr>
                <tr
                  v-for="player in scoreData.near_players"
                  :key="player.key"
                  :class="[player.key === userInfo.key ? 'highlight' : '']"
                  v-show="!showAllScores"
                >
                  <td>
                    <div>
                      <svg><use xlink:href="#golf-ball-sm"></use></svg>
                      <span>{{ String(player.rank).padStart(2, '0') }}</span>
                    </div>
                  </td>
                  <td><div>{{ shortName(player.name) }}</div></td>
                  <td>
                    <div v-if="player.club && player.club.short_name">{{ player.club.short_name }}</div>
                    <div v-else>-</div>
                  </td>
                  <td><div>{{ player.best_score }}</div></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4">
                    <div class="not-found">Engir notendur hafa náð yfir 5000 stigum!</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="club-member-list"
            :class="[clubMemberData ? 'show' : '', showLoader ? 'loading' : '']"
            ref="clubMemList"
            v-else-if="showClubMemView"
          >
            <div class="loader" v-if="showLoader"></div>
            <div class="club-selection" v-if="isClubPresentation || !mobileView">
              <div class="club-info">
                <img :src="clubInfo.image_url" alt="" height="29" width="29" v-if="!isClubPresentation" />
                <span>{{ tabView ? clubInfo.short_name : clubInfo.name }}</span>
              </div>
              <div class="club-dropdown" v-if="!mobileView">
                <el-select
                  v-if="!isClubPresentation && clubData"
                  placeholder="Other Clubs Leaderboards"
                  v-model="clubInfo.name"
                  @change="clickClubName($event)"
                >
                  <el-option
                    v-for="club in sortedClubs"
                    :key="club.key"
                    :label="club.name"
                    :value="club"
                  >
                    <span :class="(club.name == clubInfo.name) ? 'show-blue' : ''">{{ club.name }}</span>
                  </el-option>
                </el-select>
              </div>
              <div class="logo" v-if="isClubPresentation">
                <img :src="gameContent.logo" alt="" height="29" width="32" />
                <span>Regluvörður</span>
              </div>
            </div>
            <table width="100%">
              <thead>
                <tr>
                  <th width="102px"><div>Sæti</div></th>
                  <th width="325px"><div>Nafn</div></th>
                  <th width="177px"><div>Mínútur spilaðar</div></th>
                  <th><div>Stig</div></th>
                </tr>
              </thead>
              <tbody v-if="clubMemberData && clubMemberData.players.length">
                <tr
                  v-for="player in (showAllScores || isClubPresentation ? clubMemberData.players : clubMemberData.top_players)"
                  :key="player.rank + player.user_name"
                  :class="[player.user_id === userInfo.key && !isClubPresentation ? 'highlight' : '']"
                >
                  <td>
                    <div>
                      <svg v-if="player.rank === 1"><use xlink:href="#gold-crown-sm"></use></svg>
                      <svg v-else-if="player.rank === 2"><use xlink:href="#silver-crown-sm"></use></svg>
                      <svg v-else-if="player.rank === 3"><use xlink:href="#bronze-crown-sm"></use></svg>
                      <svg v-else><use xlink:href="#golf-ball-sm"></use></svg>
                      <span>{{ String(player.rank).padStart(2, '0') }}</span>
                    </div>
                  </td>
                  <td><div>{{ shortName(player.user_name) }}</div></td>
                  <td>
                    <div>
                      <svg class="clock"><use xlink:href="#clock"></use></svg>
                      <span>{{ computeMinutesTakenInTime(player.best_score_seconds) }}</span>
                    </div>
                  </td>
                  <td><div>{{ player.best_score }}</div></td>
                </tr>
                <tr
                  v-for="player in clubMemberData.near_players"
                  :key="player.rank"
                  :class="[player.user_id === userInfo.key ? 'highlight' : '']"
                  v-show="!showAllScores"
                >
                  <td>
                    <div>
                      <svg><use xlink:href="#golf-ball-sm"></use></svg>
                      <span>{{ String(player.rank).padStart(2, '0') }}</span>
                    </div>
                  </td>
                  <td><div>{{ shortName(player.user_name) }}</div></td>
                  <td>
                    <div>
                      <svg class="clock"><use xlink:href="#clock"></use></svg>
                      <span>{{ computeMinutesTakenInTime(player.best_score_seconds) }}</span>
                    </div>
                  </td>
                  <td><div>{{ player.best_score }}</div></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4">
                    <div class="not-found">Sem stendur eru engir meðlimir í félaginu þínu!</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="club-list"
            :class="[clubData ? 'show' : '', showLoader ? 'loading' : '']"
            ref="clubList"
            v-else-if="!isClubPresentation"
          >
            <div class="loader" v-if="showLoader"></div>
            <table width="100%">
              <thead>
                <tr>
                  <th width="102px"><div>Sæti</div></th>
                  <th width="325px"><div>Nafn klúbbs</div></th>
                  <th width="103px"><div>Meðlimur</div></th>
                  <th><div>Meðaltal stiga</div></th>
                </tr>
              </thead>
              <tbody v-if="clubData && clubData.clubs.length">
                <tr
                  v-for="club in (showAllScores ? clubData.clubs : clubData.top_clubs)"
                  :key="club.rank + club.name"
                  :class="[club.key === clubInfo.key ? 'highlight' : '']"
                >
                  <td>
                    <div>
                      <svg v-if="club.rank === 1"><use xlink:href="#gold-crown-sm"></use></svg>
                      <svg v-else-if="club.rank === 2"><use xlink:href="#silver-crown-sm"></use></svg>
                      <svg v-else-if="club.rank === 3"><use xlink:href="#bronze-crown-sm"></use></svg>
                      <svg v-else><use xlink:href="#golf-ball-sm"></use></svg>
                      <span>{{ String(club.rank).padStart(2, '0') }}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <img class="club" :src="club.image_url" alt="" height="25" width="25" />
                      <span>{{ club.short_name }}</span>
                    </div>
                  </td>
                  <td><div>{{ String(club.total_members).padStart(2, '0') }}</div></td>
                  <td><div>{{ ((club.total_points || 0)/(club.total_members || 1) || 0).toFixed(2) }}</div></td>
                </tr>
                <tr
                  v-for="club in clubData.near_clubs"
                  :key="club.rank"
                  :class="[club.key === clubInfo.key ? 'highlight' : '']"
                  v-show="!showAllScores"
                >
                  <td>
                    <div>
                      <svg><use xlink:href="#golf-ball-sm"></use></svg>
                      <span>{{ String(club.rank).padStart(2, '0') }}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <img class="club" :src="club.image_url" alt="" height="25" width="25" />
                      <span>{{ club.short_name }}</span>
                    </div>
                  </td>
                  <td><div>{{ String(club.total_members).padStart(2, '0') }}</div></td>
                  <td><div>{{ ((club.total_points || 0)/(club.total_members || 1) || 0).toFixed(2) }}</div></td>
                </tr>
              </tbody>
            </table>
          </div>
          <button
            type="button"
            class="btn-more"
            @click="showLoader=true;showAllScores=!showAllScores;"
            :class="{ 'show-less': showAllScores }"
            v-if="hideShowAllBtn && !isClubPresentation && !mobileView"
          >
            <span>{{ showAllScores ? 'Sýna minna' : 'Sýna öll stig' }}</span>
            <svg class="double-down-arrow"><use xlink:href="#double-down-arrow"></use></svg>
          </button>
          <div class="arrow-wrapper">
            <svg
              class="down-arrow"
              :class="{ 'show-less': showAllScores }"
              @click="showLoader=true;showAllScores=!showAllScores;"
              v-if="hideShowAllBtn && mobileView && !isClubPresentation"
            >
              <use xlink:href="#down-arrow"></use>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div :class="['popup', showShare ? 'active' : '']">
      <leaderboard-share
        v-if="showShare"
        :userInfo="userInfo"
        :pageContent="pageContent"
        :gameContent="gameContent"
        :mobileView="mobileView"
        @close="showShare=false"
      >
        <leaderboard-info
          :isShare="true"
          :userInfo="userInfo"
          :clubInfo="clubInfo"
          :clubData="clubData"
          :gameContent="gameContent"
          :pageContent="pageContent"
          :mobileView="false"
          :showClubMemView="showClubMemView"
          :showScoreView="showScoreView"
          :selectedItem="selectedItem"
          :showClubView="showClubView"
          :showAllScores="showAllScores"
          :hideShowAllBtn="hideShowAllBtn"
          :isClubPresentation="isClubPresentation"
          :hideBtn="true"
          @share="showShare=true"
        /> 
      </leaderboard-share>
    </div>
  </div>
</template>

<script>
import API from '@/shared/api'
import { ClubInfo, UserInfo } from '@/shared/dataModels'
export default {
  name: 'LeaderBoard',
  data() {
    return {
      count: 0,
      userInfo: new UserInfo(),
      clubInfo: new ClubInfo(),
      showScoreView: true,
      showClubMemView: false,
      showClubView: false,
      scoreData: null,
      clubMemberData: null,
      clubData: null,
      gameContent: {},
      pageContent: {},
      showAllScores: false,
      selectedItem: [],
      showLoader: false,
      isClubPresentation: false,
      hideShowAllBtn: false,
      mobileView: window.innerWidth <= 768,
      tabView: window.innerWidth > 767 && window.innerWidth < 1024,
      viewLimit: window.innerWidth <= 768 ? 5 : 7,
      showShare: false,
      sortedClubs: [],
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    if (this.$data.globalData.user && this.$data.globalData.user.user_club) {
      this.userInfo = this.$data.globalData.user
      this.clubInfo = this.$data.globalData.user.user_club
    }
    if (this.$data.globalData.gameContent) {
      this.gameContent = this.$data.globalData.gameContent
    }
    if (this.$data.globalData.pageContent) {
      this.pageContent = this.$data.globalData.pageContent['stigatafla']
    }
    if (this.showScoreView) {
      this.selectedItem = this.getPlayerInfo()
    }
    if (this.$route.params.clubName) {
      this.isClubPresentation = !!this.$route.params.clubName
      this.showAllScores = this.isClubPresentation
    }
    this.getClubLeaderBoard()
    if (!this.isClubPresentation) {
      this.getPlayerLeaderBoard()
    } else {
      this.showScoreView = false;
      this.showClubMemView = true;
    }
    if (!this.isClubPresentation && this.clubInfo.key) {
      this.getClubMemberLeaderBoard()
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    shortName (name) {
      return name.split(' ')[0] || '-'
    },
    getPlayerLeaderBoard () {
      API.meInstance.post('/users/leader-board/', { limit: this.viewLimit }).then((res) => {
        this.scoreData = res.data.data
        this.userInfo = { ...this.userInfo, ...this.scoreData.user }
        this.clubInfo = { ...this.clubInfo, ...this.scoreData.user.club }
        this.selectedItem = this.getPlayerInfo()
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    getClubMemberLeaderBoard () {
      API.meInstance.post(
        '/clubmember/leader-board/',
        { club_id: this.clubInfo.key, limit: this.viewLimit },
      ).then((res) => {
        this.clubMemberData = res.data.data
        this.seeAllClubs = false
        if (this.showClubMemView) this.selectedItem = this.getClubMemInfo()
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    getClubLeaderBoard() {
      API.meInstance.post(
        '/club/leader-board/',
        {
          is_club: this.isClubPresentation,
          club_name: decodeURIComponent(this.$route.params.clubName),
          limit: this.viewLimit,
        },
      ).then((res) => {
        this.clubData = res.data.data
        this.sortedClubs = this.clubData.clubs.toSorted((a, b) => a.name.localeCompare(b.name))
        if (this.isClubPresentation) {
          this.clubInfo = { ...this.clubData.current_club }
          this.getClubMemberLeaderBoard()
          return
        }
        if (!this.clubInfo.key) {
          this.clubInfo = { ...this.clubData.clubs[0] }
          this.getClubMemberLeaderBoard()
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    computeMinutesTakenInTime(seconds = 0) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    },
    computesMinutes(seconds = 0) {
      const castSeconds = Number.isInteger(seconds) ? seconds : seconds.toFixed(2);
      return castSeconds < 60 ? `${castSeconds}s` : `${Math.floor(castSeconds / 60)}m`;
    },
    getPlayerInfo() {
      if (!this.userInfo) return [];
      return [
        { title: 'Hæsta skor', value: this.userInfo.best_score || 0 },
        { title: 'Spilunartími', value: this.computesMinutes(this.userInfo.best_score_seconds) },
        { title: 'Fjöldi sigra', value: this.userInfo.total_games_won || 0 },
        { title: 'Fjöldi spilana', value: this.userInfo.total_turns_played || 0 },
        { title: 'Meðal spilatími', value: this.computesMinutes(this.userInfo.total_seconds_taken/this.userInfo.total_turns_played || 0) },
        { title: "Sæti klúbbs", value: this.userInfo.user_club && this.userInfo.user_club.key ? (this.clubInfo.rank || 0) : '-' },
      ]
    },
    getClubMemInfo() {
      if (!this.clubInfo) return [];
      return [
        { title: 'Fjöldi meðlima', value: this.clubInfo.total_members || 0 },
        { title: 'Meðalfjöldi stiga', value: ((this.clubInfo.total_points || 0)/(this.clubInfo.total_members || 1)).toFixed(2) },
        { title: 'Meðal spilatími', value: this.computesMinutes(this.clubInfo.total_seconds_taken/(this.clubInfo.total_members || 1) || 0) },
        { title: 'Fjöldi verðlauna', value: this.clubInfo.total_medals || 0 },
      ]
    },
    clickClubName(clubDetail) {
      this.clubInfo = { ...clubDetail }
      this.selectedItem = this.getClubMemInfo()
      this.getClubMemberLeaderBoard()
    },
    handleResize() {
      this.mobileView = window.innerWidth <= 768
      this.tabView = window.innerWidth > 767 && window.innerWidth < 1024
      if (this.mobileView) this.viewLimit = 5
      else this.viewLimit = 7
    },
  },
  watch: {
    showAllScores() {
      setTimeout(() => {
        this.showLoader = false
      }, 3000)
    },
    showScoreView(newVal) {
      if (!newVal) return
      this.selectedItem = this.getPlayerInfo()
      this.hideShowAllBtn = this.scoreData && this.scoreData.players.length > 10
    },
    showClubMemView(newVal) {
      if (!newVal) return
      this.selectedItem = this.getClubMemInfo()
      this.hideShowAllBtn = this.clubMemberData && this.clubMemberData.players.length > 10
    },
    showClubView(newVal) {
      if (!newVal) return
      this.selectedItem = this.getClubMemInfo()
      this.hideShowAllBtn = this.clubData && this.clubData.clubs.length > 10
    },
    scoreData(newVal) {
      if (this.showScoreView) this.hideShowAllBtn = newVal.players.length > 10
      if (!newVal || !this.clubMemberData || !this.clubData) {
        this.showLoader = true
        return
      }
      this.showLoader = false
    },
    clubMemberData(newVal) {
      if (this.showClubMemView) this.hideShowAllBtn = newVal.players.length > 10
      if (this.isClubPresentation) {
        this.showLoader = !this.clubMemberData
        return
      }
      if (!newVal || !this.scoreData || !this.clubData) {
        this.showLoader = true
        return
      }
      this.showLoader = false
    },
    clubData(newVal) {
      if (this.showClubView) this.hideShowAllBtn = newVal.clubs.length > 10
      if (this.isClubPresentation) {
        this.showLoader = !this.clubData
        return
      }
      if (!newVal || !this.scoreData || !this.clubMemberData) {
        this.showLoader = true
        return
      }
      this.showLoader = false
    },
    showLoader (newVal) {
      if (!newVal && this.showAllScores) {
        this.$nextTick(() => {
          if (this.showScoreView) this.$refs.scoreList.scrollTo({ top: 200, behavior: 'smooth' });
          if (this.showClubMemView) this.$refs.clubMemList.scrollTo({ top: 200, behavior: 'smooth' });
          if (this.showClubView) this.$refs.clubList.scrollTo({ top: 200, behavior: 'smooth' });
        })
      } else if (!this.showAllScores) {
        if (this.showScoreView) this.$refs.scoreList.scrollTop = 0;
        if (this.showClubMemView) this.$refs.clubMemList.scrollTop = 0;
        if (this.showClubView) this.$refs.clubList.scrollTop = 0;
      }
    } 
  }
}
</script>

<style lang="scss">
.leaderboard-page {
  .inner {
    .club-dropdown {
      max-width: 217px;
      width: 100%;
      .el-select .el-input__inner {
        box-shadow: none;
        border: 0.5px solid #CCD0D4;
        border-radius: 6px;
        padding: 11px 16px;
        font-weight: 500;
        font-size: 14px;
        line-height: 18.48px;
        color: #808A93;
        display: flex;
        align-items: center;
        gap: 16px;
        justify-content: space-between;
        height: 46px;
      }
    }
    &.club-presentation {
      .club-dropdown {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@keyframes pulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
.leaderboard-page {
  color: #011627;
  position: relative;
  .leaderboard-container {
    height: calc(100dvh - var(--mobile-header-height));
    overflow: auto;
    .bg-image {
      background-size: cover;
      height: 217px;
      width: 100vw;
      background-repeat: no-repeat;
      background-position: top center;
    }
  }
  .note {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 16px;
    .pre-title {
      /deep/ p {
        font-size: 18px;
        line-height: 21.6px;
        color: #011627;
        margin: 0;
      }
    }
    svg.golf-ball-stand {
      height: 40px;
      width: 25px;
    }
  }
  .inner {
    padding: 65px 22px 20px 15px;
    display: flex;
    justify-content: center;
    gap: 76px;
    .leaderboard-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 682px;
      width: 100%;
      position: relative;
      .title {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 24px;
        span {
          font-weight: 600;
          font-size: 24px;
          line-height: 28.8px;
          text-transform: uppercase;
        }
      }
      .btn-wrapper {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
        button {
          font-weight: 600;
          font-size: 14px;
          line-height: 18.48px;
          border-radius: 5px;
          padding: 10px;
          border: 1px solid #CCD0D4;
          min-width: 112px;
          &.active {
            background: #FFFFFF;
            border: 1px solid #FCBD00;
          }
        }
      }
      .score-list, .club-member-list, .club-list {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 0px 8px 31px 8px;
        overflow: auto;
        margin-bottom: 16px;
        position: relative;
        min-height: 250px;
        max-height: 0;
        transition: max-height 0.5s ease-in-out;
        &.loading {
          overflow: hidden;
        }
        &.show {
          max-height: 542px;
        }
        &::after {
          content: "";
          position: sticky;
          bottom: -31px;
          height: 31px;
          left: 0;
          right: 0;
          background: #ffffff;
          display: block;
        }
        .loader {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          background-color: rgba(255, 255, 255, 0.5);
          &::after {
            content: "";
            position: absolute;
            width: 40px;
            height: 40px;
            margin: 100px auto;
            background-color: grey;
            border-radius: 100%;
            animation: pulse 1.2s infinite ease-in-out;
          }
        }
        .club-selection {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0 10px;
          margin: 24px 14px 16px;
          .club-info {
            display: flex;
            align-items: center;
            gap: 8px;
            img {
              height: 29px;
              width: 29px;
            }
            span {
              font-weight: 600;
              font-size: 16px;
              line-height: 19.2px;
              color: #000000;
              text-transform: uppercase;
            }
          }
          .logo {
            display: flex;
            align-items: center;
            gap: 12px;
          }
        }
        table {
          thead {
            tr {
              position: sticky;
              top: 0px;
              z-index: 1;
              background-color: #ffffff;
            }
            th {
              font-weight: 500;
              font-size: 14px;
              line-height: 18.48px;
              color: #8F969B;
              >div {
                padding: 26px 16px 10px;
                white-space: nowrap;
              }
            }
          }
          tbody {
            tr {
              td {
                font-size: 16px;
                line-height: 21.12px;
                padding: 12px 16px 12px;
                vertical-align: top;
                &:first-child, &:last-child {
                  font-weight: 600;
                }
                &:nth-child(2) {
                  line-break: anywhere;
                }
                > div {
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  svg {
                    height: 20px;
                    width: 25px;
                  }
                }
                svg.clock {
                  height: 18px;
                  width: 14px;
                }
                .not-found {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 30px 10px;
                  font-weight: 500;
                  opacity: 0.8;
                }
              }
              &.highlight {
                td {
                  padding: 0;
                  >div {
                    background: #FEF2CC;
                    padding: 12px 16px 12px;
                    height: 42px;
                  }
                  &:first-child >div {
                    border-radius: 10px 0 0 10px;
                  }
                  &:last-child >div {
                    border-radius: 0 10px 10px 0;
                  }
                }
              }
              &:last-child {
                td {
                  padding-bottom: 0px;
                }
              }         
            }
          }
        }
        img.coin {
          width: 25px;
          height: 28px;
        }
        img.club {
          width: 21px;
          height: 21px;
        }
        .divider {
          border: 0.5px solid #CCD0D4;
          width: 301px;
          margin: 0 auto;
        }
      }
      .btn-more {
        background: none;
        border: none;
        outline: none;
        font-weight: 600;
        font-size: 16px;
        line-height: 19.2px;
        color: #808A93;
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: 8px;
        margin: 0 auto;
        &.show-less {
          align-items: center;
          svg.double-down-arrow {
            transform: rotateZ(180deg);
          }
        }
        svg.double-down-arrow {
          height: 14px;
          width: 14px;
          transition: all 0.3s ease-in-out;
        }
      }
    }
    &.club-presentation {
      margin-top: -140px;
      .leaderboard-info {
        margin-top: 0;
      }
      .leaderboard-list {
        .club-member-list {
          .club-selection {
            .logo {
              span {
                font-weight: 600;
                font-size: 18px;
                line-height: 21.6px;
                color: #011627;
              }
            }
          }
          table {
            thead {
              th {
                >div {
                  padding-top: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.2);
    display: none;
    &.active {
      display: flex;
      align-items: flex-start;
      justify-content: center;
    }
    .leaderboard-share {
      z-index: 4;
    }
  }
}

@media screen and (max-width: 950px) {
  .leaderboard-page {
    .inner {
      gap: 24px;
    }
  }  
}

@media screen and (max-width: 768px) {
  .leaderboard-page {
    .leaderboard-container {
      height: 100dvh;
      padding-top: var(--mobile-header-height);
      .bg-image {
        height: 64px;
      }
    }
    .inner {
      flex-direction: column;
      justify-content: revert;
      padding: 16px 18px 16px;
      gap: 24px 0;
      align-items: center;
      margin-top: -64px;
      .leaderboard-list {
        align-items: flex-start;
        margin-bottom: 66px;
        .title {
          order: 2;
          background-color: #ffffff;
          border-radius: 0 19px 0 0;
          margin-bottom: 0;
          z-index: 1;
          padding: 16px 10px 0px;
          width: 100%;
          img {
            height: 30px;
            width: 30px;
          }
          span {
            font-weight: 700;
            font-size: 14px;
            line-height: 16.8px;
            color: #000000;
          }
        }
        .btn-wrapper {
          order: 1;
          margin-bottom: 0;
          gap: 4px;
          button {
            padding: 8px 24px;
            border-radius: 5px 5px 0px 0px;
            box-shadow: 0px 0px 50px 0px #0000001A;
            font-size: 12px;
            line-height: 15.84px;
            color: #011627;
            font-weight: 500;
            border: none;
            background: #E0E0E0;
            min-width: auto;
            width: auto;
            white-space: nowrap;
            &.active {
              background: #ffffff;
              border: none;
            }
          }
        }
        .score-list, .club-member-list, .club-list {
          order: 3;
          border-radius: 0 0 19px 19px;
          margin-bottom: 0;
          &.show {      
            max-height: 366px;
          }
          &::after {
            display: none;
          }
          table {
            thead {
              th {
                >div {
                  padding: 20px 6px 9px;
                  font-size: 12px;
                  line-height: 15.84px;
                  font-weight: 400;
                  color: #808A93;
                }
              }
            }
            tbody {
              tr {
                td {
                  padding: 7px 6px;
                  font-size: 14px;
                  line-height: 18.48px;
                }
                &.highlight {
                  td {
                    > div {
                      padding: 6px 6px;
                      height: 31px;
                    }
                  }
                }
              }
            }
          }
        }
        .arrow-wrapper {
          bottom: 0;
          margin: 0 auto;
          position: absolute;
          left: 0;
          right: 0;
          height: 31px;
          background: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
          border-radius: 0 0 19px 19px;
          svg.down-arrow {
            height: 11px;
            width: 11px;
            transition: all 0.3s ease-in-out;
            &.show-less {
              transform: rotateZ(180deg);
            }
          }
        }
      }
      &.club-presentation {
        margin-top: -64px;
        .leaderboard-list {
          .club-member-list {
            border-radius: 19px;
            .club-selection {
              margin: 16px 10px 10px;
              .club-info span, .logo span {
                font-weight: 500;
                font-size: 14px;
                line-height: 16.8px;
              }              
            }
          }
        } 
      }
    }
    .popup {
      .leaderboard-share {
        width: 100%;
      }
    }
  }
}
</style>